import { render } from "./RequestRemainingDuration.vue?vue&type=template&id=2bb8761c&scoped=true"
import script from "./RequestRemainingDuration.vue?vue&type=script&lang=js"
export * from "./RequestRemainingDuration.vue?vue&type=script&lang=js"

import "./RequestRemainingDuration.vue?vue&type=style&index=0&id=2bb8761c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb8761c"]])

export default __exports__